'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = _interopRequireDefault(require("cleave.js/react"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _Input = _interopRequireDefault(require("@material-ui/core/Input"));
var _groupingString = _interopRequireDefault(require("Components/Forms/Functions/groupingString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class TextInput extends _react.Component {
  state = {
    id: ++app.form_index
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (typeof props.onChange !== 'function') return;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: props['default-value'] || '',
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props,
      state = this.state;
    let value = e.target.value;
    if (props.onChange) {
      props.onChange({
        e: e,
        value: value,
        name: props.name
      });
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (props.status || {})[props.name];
    const error_msg = status?.error ? /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, status.error) : undefined;
    const prefix = props.prefix ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "start"
    }, props.prefix) : undefined;
    const suffix = props.suffix ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, props.suffix) : undefined;
    const text_field_component = props.input_format && props.onChange ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, props.label), /*#__PURE__*/_react.default.createElement(_react2.default, {
      id: String(state.id),
      options: props.input_format,
      onChange: component.handleChange,
      name: props.name,
      value: props.value || '',
      className: "cleave_textinput"
    })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
      htmlFor: String(state.id)
    }, props.label), /*#__PURE__*/_react.default.createElement(_Input.default, {
      id: String(state.id),
      className: props['read-only'] ? 'read-only_textinput' : '',
      onChange: component.handleChange,
      value: props.input_format?.blocks ? (0, _groupingString.default)(props.value, props.input_format.blocks) : props.value || '',
      disabled: props['read-only'] === true,
      name: props.name,
      type: props.type || 'text',
      required: props.required || false,
      multiline: props.multiline || false,
      rows: props.rows || '1',
      autoComplete: props.autoComplete,
      startAdornment: prefix,
      endAdornment: suffix
    }));
    const full_width = ![false, 'false'].includes(props.full_width);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: props.className || (full_width ? 'u-full-width' : '')
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      fullWidth: full_width,
      error: status && status.error ? true : false,
      style: {
        fontFamily: 'inherit'
      }
    }, text_field_component, error_msg));
  }
}
exports.default = TextInput;
